const AUTH_TOKEN_KEY = 'auth_token';
const LOCAL_AUTH_STORAGE_PREFIXES = ['CognitoIdentityServiceProvider', 'aws.cognito.'];
const AMPLIFY_OAUTH_STORAGE_KEYS = ['amplify-signin-with-hostedUI'];
const AMPLIFY_OAUTH_STORAGE_SUFFIXES = ['.inflightOAuth', '.oauthSignIn', '.oauthPKCE', '.oauthState'];

const getBrowserSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.sessionStorage;
};

const getBrowserLocalStorage = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.localStorage;
};

const shouldRemoveLocalStorageKey = (key) => {
    const isAmplifyOAuthStorageKey =
        AMPLIFY_OAUTH_STORAGE_KEYS.includes(key) ||
        AMPLIFY_OAUTH_STORAGE_SUFFIXES.some((suffix) => key.endsWith(suffix));

    // Amplify stores the OAuth state and PKCE verifier in local storage even
    // when Cognito tokens use session storage. Clearing these keys while the
    // redirect callback is loading prevents the authorization-code exchange.
    if (isAmplifyOAuthStorageKey) {
        return false;
    }

    return key === AUTH_TOKEN_KEY || LOCAL_AUTH_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix));
};

export const clearLocalAuthStorage = () => {
    const storage = getBrowserLocalStorage();
    if (!storage) {
        return;
    }

    Object.keys(storage).forEach((key) => {
        if (shouldRemoveLocalStorageKey(key)) {
            storage.removeItem(key);
        }
    });
};

export const getAuthToken = () => {
    const sessionStorage = getBrowserSessionStorage();
    const localStorage = getBrowserLocalStorage();
    const token = sessionStorage?.getItem(AUTH_TOKEN_KEY) || localStorage?.getItem(AUTH_TOKEN_KEY);

    if (token && sessionStorage?.getItem(AUTH_TOKEN_KEY) !== token) {
        sessionStorage?.setItem(AUTH_TOKEN_KEY, token);
    }

    clearLocalAuthStorage();
    return token;
};

export const setAuthToken = (token) => {
    const storage = getBrowserSessionStorage();

    if (!token) {
        storage?.removeItem(AUTH_TOKEN_KEY);
        clearLocalAuthStorage();
        return;
    }

    storage?.setItem(AUTH_TOKEN_KEY, token);
    clearLocalAuthStorage();
};

export const clearAuthToken = () => {
    getBrowserSessionStorage()?.removeItem(AUTH_TOKEN_KEY);
    clearLocalAuthStorage();
};

export const configureAwsCognitoIdentityStorage = (AWS) => {
    const storage = getBrowserSessionStorage();
    if (!AWS?.CognitoIdentityCredentials?.prototype || !storage) {
        return;
    }

    AWS.CognitoIdentityCredentials.prototype.storage = storage;
    clearLocalAuthStorage();
};
